import { $Q } from "../utils/query-selector";

const readFormResponse = () => {
  if (
    window.location.search.includes('newsletter-account') ||
    window.location.search.includes('customer_posted=true')
    ) {

    setTimeout(() => {
      $Q('li[data-id="newsletter"]').click();

      if (sessionStorage.getItem('subscribe-account')) {
        hideDuplicatedMessage();
        sessionStorage.removeItem('subscribe-account');
      }
    }, 0);
  }
}

const readSubscribeButton = () => {
  $Q('#contact_account_form') && $Q('#contact_account_form').addEventListener('submit', () => {
    sessionStorage.setItem('subscribe-account', true);
  })
}

const hideDuplicatedMessage = () => {
  const newsletterWrapper = $Q('#shopify-section-newsletter .newsletter-form__wrapper');
  if (!newsletterWrapper) return;

  const siblingMessage = newsletterWrapper.nextElementSibling;
  siblingMessage.classList.add('hidden');
}

export const handleAccountNewsletter = () => {
  window.addEventListener('DOMContentLoaded', () => {
    readFormResponse();
    readSubscribeButton();
  })
}
